module.exports = __webpack_public_path__ + "img/sponsor4.6399a34d.png";